var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.75 17c.691 0 1.25.447 1.25 1s-.559 1-1.25 1h-2.5c-.691 0-1.25-.447-1.25-1s.559-1 1.25-1Zm3.95-6c.719 0 1.3.447 1.3 1s-.581 1-1.3 1H7.3c-.719 0-1.3-.447-1.3-1s.581-1 1.3-1Zm3.05-6c.691 0 1.25.447 1.25 1s-.559 1-1.25 1H3.25C2.559 7 2 6.553 2 6s.559-1 1.25-1Z"
})));
export default SvgGemFilter;